export default "__VITE_ASSET__D81z3ZvW__"